import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { studyLabManagementServices } from "../../../../APIServices/studyLabManagementServices";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { studySiteManagementServices } from "../../../../APIServices/CTMS/SiteManagement/studySiteManagementServices";


const AddLabManagementForm = ({ getStudyLabManagementRowData }) => {
  let { studyId } = useParams();
  const [labManagementColumns, setLabManagementColumns] = useState([]);
  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [formId, setFormId] = useState("");
  const [formName, setFormName] = useState("");
  const [version, setVersion] = useState("");
  const [formList, setFormList] = useState([]);
  const [mainVersion, setMainVersion] = useState("");
  const [formFields, setFormFields] = useState([]);
  const [selectedTest, setSelectedTest] = useState([]);
  const [labManagementRows, setLabManagementRows] = useState([]);
  const [siteId, setSiteId] = useState("");
  const [siteList, setSiteList] = useState([]);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  const getStudySiteBasedonAccess = async () => {
    let data = await studySiteManagementServices.getStudySiteBasedonAccess(studyId, LoginCat, StudyMode)
    let sites = data?.data || []
    setSiteList(sites)
    setSiteId(sites[0]?.siteId)
  }

  const getStudyLabManagementColumnData = async (e) => {
    setLoader(true);
    let data =
      await studyLabManagementServices.getStudyLabManagementColumnData(
        "active",
        studyId
      );
    setLabManagementColumns(data?.data || []);
    setLoader(false);
  };

  const getStudyLevelForm = async (e) => {
    let data = await studyLevelFormManagementServices.getStudyLevelForm(
      studyId,
      "edc",
      "active",
      StudyMode
    );
    setFormList(data?.data || [])
  };

  const getStudyLevelFormFieldsByVersion = async () => {
    let data = await studyLevelFormManagementServices.getStudyLevelFormFieldsByVersion(
      studyId,
      formId,
      version
    );
    if (data === "AbortError") {
      setFormFields([]);
    } else {
      let result = data?.data?.formFields || []
      let customField = result?.filter(item => item.customField === "yes")
      setFormFields(customField);
    }
  };

  const getStudyLabManagementRow = async (e) => {
    let data = await studyLabManagementServices.getStudyLabManagementRowData(
      "all",
      studyId,
      "all"
    );
    let result = data?.data || []
    let finalResult = result?.map(item => ({
      testName: item.row.TESTNAME,
      siteId: item?.siteId
    }));

    let uniqueKey = finalResult.filter(
      (value, index, self) =>
        index === self.findIndex(
          t => t.testName === value.testName && t.siteId === value.siteId
        )
    );

    setLabManagementRows(uniqueKey);
  };

  const addNewStudyLabManagementRow = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.siteId = siteId;
    userData.formId = formId;
    userData.version = version;
    userData.testList = selectedTest;
    let data = await studyLabManagementServices.addNewStudyLabManagementRow(
      userData
    );
    if (data?.statusCode === 200) {
      getStudyLabManagementColumnData();
      getStudyLabManagementRowData();
      getStudyLabManagementRow();
      setSelectedTest([])
      setFormName("")
      setFormId("")
      setVersion("")
      setMainVersion("")
    }
    setButtonLoader(false);
  };

  const handleCheckField = (e, item) => {
    const { checked } = e.target;

    if (checked) {
      setSelectedTest((prev) => [
        ...prev,
        {
          FORMNAME: formName,
          TESTLABEL: item.fieldLabel,
          TESTNAME: item.fieldName,
          id: item.id,
        },
      ]);
    } else {
      setSelectedTest((prev) =>
        prev.filter((obj) => obj.id !== item.id)
      );
    }
  };

  const handleSelectAll = (e) => {
    const { checked } = e.target;
    if (checked) {
      const allItems = formFields
        .filter(
          (item) =>
            !labManagementRows.some(
              (lab) => lab?.testName === item?.fieldName && lab?.siteId === siteId
            )
        )
        .map((item) => ({
          FORMNAME: formName,
          TESTLABEL: item.fieldLabel,
          TESTNAME: item.fieldName,
          id: item.id,
        }));

      setSelectedTest(allItems);
    } else {
      setSelectedTest([]);
    }
  };

  useEffect(() => {
    getStudyLabManagementRow()
    getStudyLabManagementColumnData();
    getStudyLevelForm()
  }, []);

  useEffect(() => {
    if (formId && version) {
      getStudyLevelFormFieldsByVersion()
    }
  }, [formId, version]);

  useEffect(() => {
    getStudySiteBasedonAccess()
  }, []);

  useEffect(() => {
    setSelectedTest([])
  }, [siteId]);

  return (
    <>
      {loader ? (
        <PageLoader />
      ) : labManagementColumns?.length === 0 ? (
        <div className="hstack justify-content-center h-100">
          <NoDataFoundTable MSG={"First create Lab Management metadata"} />
        </div>
      ) : (
        <div className="p-2">
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Site{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => setSiteId(e.target.value)}
              className="br3"
              disabled={siteList?.length === 0}
              style={{ fontSize: 12 }}
            >
              <option selected={siteId === ""} value="">Select Site</option>
              {siteList.map((item, index) => (
                <option key={index} value={item.siteId}>
                  {item.row?.SITEID}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Form{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => { setFormId(e.target.value); setMainVersion(e.target[e.target.selectedIndex].id); setFormName(e.target[e.target.selectedIndex].title) }}
              className="br3"
              disabled={formList?.length === 0}
              style={{ fontSize: 12 }}
            >
              <option selected={formId === ""} value="">Select Form</option>
              {formList?.map((item, index) => (
                <option key={index} selected={formId === item?.formId} value={item?.formId} id={item?.version} title={item?.formName}>{item?.formName}</option>
              ))}
            </Form.Select>
          </Form.Group>
          {formId &&
            <Form.Group className="mb-1">
              <Form.Label className="fw-bold mb-1">
                Form Version{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Select
                onChange={(e) => setVersion(e.target.value)}
                className="br3"
                disabled={!mainVersion}
                style={{ fontSize: 12 }}
              >
                <option selected={version === ""} value="">Select Version</option>
                {Array.from({ length: mainVersion }, (_, i) => i + 1)?.reverse()?.map((versionNumber, index) => (
                  <option key={index} selected={Number(version) === versionNumber} value={versionNumber}>Version {versionNumber}</option>
                ))}
              </Form.Select>
            </Form.Group>
          }
          {formId && version &&
            <Form.Group className="mb-1">
              <Form.Label className="fw-bold mb-1">
                Select Test{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Check
                type="checkbox"
                label="Select All"
                id="select-all"
                checked={
                  formFields?.length > 0 &&
                  formFields.every(
                    (item) =>
                      labManagementRows.some(
                        (lab) => lab?.testName === item?.fieldName && lab?.siteId === siteId
                      ) ||
                      selectedTest.some(
                        (obj) => obj.id === item.id && obj.TESTNAME === item.fieldName
                      )
                  )
                }
                onChange={(e) => handleSelectAll(e)}
              />

              {formFields?.map((item, index) => (
                <Form.Check
                  key={index}
                  type="checkbox"
                  label={item?.fieldLabel}
                  value={item?.fieldName}
                  id={item?.id}
                  disabled={labManagementRows.some(
                    (lab) => lab?.testName === item?.fieldName && lab?.siteId === siteId
                  )}
                  checked={selectedTest.some(
                    (obj) => obj.id === item.id && obj.TESTNAME === item.fieldName
                  )}
                  onChange={(e) => handleCheckField(e, item)}
                />
              ))}
            </Form.Group>

          }
          <div className="text-end">
            <button
              disabled={!siteId || !formId || !version || buttonLoader || selectedTest?.length === 0}
              title={"Add Test"}
              onClick={addNewStudyLabManagementRow}
              className="updateProfile"
            >
              {buttonLoader ? (
                <div className="hstack gap-2">
                  <Spinner size="sm" /> Adding...
                </div>
              ) : (
                "Add Test"
              )}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default AddLabManagementForm;
